module.exports = __webpack_public_path__ + "static/media/6_1.b94ee231.png";